import { Extension, JSONContent } from '@tiptap/core';

declare module '@tiptap/core' {
   interface Commands<ReturnType> {
      originalState: {
         updateSavedContent: () => ReturnType;
      };
   }
}

interface OriginalStateStorage {
   savedContent: null | JSONContent;
}

export const OriginalState = Extension.create<any, OriginalStateStorage>({
   name: 'originalState',

   addCommands() {
      return {
         updateSavedContent:
            () =>
            ({ dispatch }) => {
               if (dispatch) {
                  this.storage.savedContent = this.editor.getJSON();
               }
               return true;
            },
      };
   },

   onCreate() {
      this.editor.commands.updateSavedContent();
   },

   addStorage() {
      return {
         savedContent: null,
      };
   },
});
